<template>
  <section
    data-aos="fade"
    class="overflow-hidden text-gray-800 pt-24 sm:pt-32 sm:pb-8 md:pb-32"
  >
    <div class="mx-auto max-w-7xl md:px-6 lg:px-8">
      <div
        class="grid grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:grid-cols-2 lg:items-start"
      >
        <div data-aos="fade-up" class="px-6 lg:px-0 lg:pt-4 lg:pr-4">
          <div class="mx-auto max-w-2xl relative lg:mx-0 lg:max-w-lg">
            <img
              :src="GreenStar"
              alt="Green star drawing squiggle"
              class="absolute right-0 -top-8"
              height="48"
              width="48"
            />
            <h2 class="text-base/7 font-semibold text-purple-400">
              Points & Awards
            </h2>
            <p
              class="mt-2 text-4xl font-semibold tracking-tight text-pretty sm:text-5xl"
            >
              Real-time classroom moments
            </p>
            <p class="mt-6 text-lg/8 text-gray-600">
              Capturing special moments in school and share them with parents
              and contacts at home.
            </p>
            <dl
              class="mt-10 max-w-xl space-y-8 text-base/7 text-gray-600 lg:max-w-none"
            >
              <div
                v-for="item in list"
                :key="item.id"
                class="relative flex flex-col"
              >
                <dt class="inline font-semibold text-gray-800">
                  <i class="text-purple-600 me-2" :class="item.icon"></i>
                  {{ item.title }}
                </dt>
                <dd class="inline">
                  {{ item.body }}
                </dd>
              </div>
            </dl>
          </div>
        </div>
        <div data-aos="fade-left" class="sm:px-6 lg:px-0">
          <div
            class="relative isolate overflow-hidden bg-purple-500 px-6 pt-8 min-h-[600px] sm:mx-auto sm:max-w-2xl sm:rounded-3xl sm:pt-16 sm:pr-0 sm:pl-16 lg:mx-0 lg:max-w-none"
          >
            <div
              class="absolute -inset-y-px -left-3 -z-10 w-full origin-bottom-left skew-x-[-30deg] bg-purple-100 opacity-20 ring-1 ring-white ring-inset"
              aria-hidden="true"
            ></div>
            <div class="mx-auto max-w-2xl sm:mx-0 sm:max-w-none">
              <img
                :src="Mockup"
                alt="mockup"
                class="absolute w-96 bottom-0 right-0"
                height="600"
                width="384"
                loading="lazy"
              />
            </div>
            <div
              class="pointer-events-none absolute inset-0 ring-1 ring-black/10 ring-inset sm:rounded-3xl"
              aria-hidden="true"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import Mockup from "/mockups/1.webp";
import GreenStar from "/graphics/green/star.svg";

const list = [
  {
    id: 1,
    title: "Recognition for achievements",
    body: "Award points or badges to pupils or entire classes in just a few taps — on the spot, when it matters most.",
    icon: "fas fa-stars",
  },
  {
    id: 2,
    title: "Add meaning with observations",
    body: "Attach context, images and notes to every award so parents see the why, not just the what.",
    icon: "fas fa-camera",
  },
  {
    id: 3,
    title: "Support academic and personal growth",
    body: "Use rewards to build morale, highlight values and promote progress in your classroom.",
    icon: "fas fa-party-horn",
  },
];
</script>
